<template>
  <div class="integration-card">
    <!--START: App details-->
    <div class="app-details">
      <img :src="logoUrl" class="app-logo" :alt="provider.name" />
      <div class="app-info">
        <h3>{{ provider.name }}</h3>
        <p>{{ provider.description }}</p>
      </div>
    </div>
    <!--END: App details-->

    <!--START: Actions-->
    <div class="card-actions">
      <button
        v-if="!provider.isConnected"
        class="btn btn-grey btn-small"
        @click="$emit('connect', provider)"
      >
        Connect
      </button>

      <div v-else class="connected-row">
        <span class="table-tag green">Connected</span>
        <div class="connected-controls">
          <button
            class="btn btn-text btn-small btn-no-padding"
            @click="$emit('disconnect', provider)"
          >
            Disconnect
          </button>
          <label class="toggle-wrapper">
            <input
              type="checkbox"
              :checked="provider.isActive"
              @change="onToggle"
            />
            <span class="toggle-slider"></span>
          </label>
        </div>
      </div>
    </div>
    <!--END: Actions-->
  </div>
</template>

<script>
export default {
  name: "IntegrationCard",
  props: {
    provider: {
      type: Object,
      required: true,
    },
  },
  computed: {
    logoUrl() {
      if (!this.provider.logo) return "";
      try {
        return require(`@/assets/images/apps/${this.provider.logo}`);
      } catch (e) {
        return require("@/assets/images/no-image.png");
      }
    },
  },
  methods: {
    onToggle(event) {
      this.$emit("toggle", {
        provider: this.provider,
        isActive: event.target.checked,
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/shared/dashboard.scss";

.integration-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1.25rem;
  border: 1px solid lighten($lightGreyColor, 20%);
  border-radius: 0.75rem;
  background-color: $whiteColor;
  @include transition;
}

.app-details {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 0.85rem;
  margin-bottom: 1rem;
}

.app-logo {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.5rem;
  border: 1px solid lighten($lightGreyColor, 20%);
  object-fit: contain;
  flex-shrink: 0;
}

.app-info {
  h3 {
    font-size: $smallFontSize;
    margin-bottom: 0.15rem;
  }

  p {
    font-size: $smallerFontSize;
    color: $paragraphColor;
    line-height: 1.4;
    margin-bottom: 0;
  }
}

.card-actions {
  .btn {
    width: 100%;
    justify-content: center;
  }
}

.connected-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.connected-controls {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.65rem;

  .btn {
    width: auto;
  }
}

.toggle-wrapper {
  position: relative;
  display: inline-block;
  width: 2.25rem;
  height: 1.25rem;
  cursor: pointer;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .toggle-slider {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: lighten($greyColor, 40%);
    border-radius: 1rem;
    @include transition;

    &::before {
      content: "";
      position: absolute;
      height: 0.9rem;
      width: 0.9rem;
      left: 0.175rem;
      bottom: 0.175rem;
      background-color: $whiteColor;
      border-radius: 50%;
      @include transition;
    }
  }

  input:checked + .toggle-slider {
    background-color: $greenColor;
  }

  input:checked + .toggle-slider::before {
    transform: translateX(1rem);
  }
}
</style>
